import {get} from "lodash"
import BaseService from "./Base"
import {
    ListUserUiTableColumnSettingsPayload,
    SaveUserUiTableColumnSettingsPayload,
    UserUiTableColumnSettingRow
} from "types/userUiTableColumnSettings"

class UserUiTableColumnSettingsService extends BaseService {
    async list(
        payload: ListUserUiTableColumnSettingsPayload = {},
        params = {}
    ): Promise<UserUiTableColumnSettingRow[]> {
        const response = await this.post("/v1/users/ui-table-column-settings/list", payload, params)
        return get(response, "data.data", get(response, "data", []))
    }

    async save(payload: SaveUserUiTableColumnSettingsPayload, params = {}) {
        const response = await this.post("/v1/users/ui-table-column-settings/save", payload, params)
        return get(response, "data.data", {})
    }
}

export default UserUiTableColumnSettingsService
